/**
 * Checks if the provided value is a valid UUID (version 4).
 */
export const fnValidUuidV4 = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
};

/**
 * Validates whether a given string is a valid UUID version 7.
 */
export const fnValidUuidV7 = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  return /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
};

/**
 * Validates whether a given string is a valid UUID (Universally Unique Identifier).
 */
export const fnValidUuid = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
};
